import { ConfigStateService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { format, parse } from 'date-fns';
import {
  DEFAULT_DATETIME_FORMAT_SHORT_DATE_PATTERN,
  LOCALIZATION__CURRENT_CULTURE__DATETIME_FORMAT__SHORT_DATE_PATTERN,
} from './dw-date-pipe-adapter';

@Injectable()
export class DwDateParserFormatter extends NgbDateParserFormatter {
  private readonly USER_DATE_FORMAT: string;

  constructor(private configStateService: ConfigStateService) {
    super();

    this.USER_DATE_FORMAT =
      (this.configStateService.getDeep(
        LOCALIZATION__CURRENT_CULTURE__DATETIME_FORMAT__SHORT_DATE_PATTERN,
      ) as string) ?? DEFAULT_DATETIME_FORMAT_SHORT_DATE_PATTERN;
  }

  parse(value: string): NgbDateStruct {
    if (
      value != null &&
      this.USER_DATE_FORMAT != null &&
      value.length == this.USER_DATE_FORMAT.length
    ) {
      const parsedDate = parse(value, this.USER_DATE_FORMAT, new Date());
      return {
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth() + 1,
        day: parsedDate.getDate(),
      };
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (date != null && this.USER_DATE_FORMAT != null) {
      const formattedDate = new Date(date.year, date.month - 1, date.day);
      return format(formattedDate, this.USER_DATE_FORMAT);
    }
    return null;
  }
}
